import type { SearchFilters } from "@outschool/gql-backend-generated";

export const fundingProgramFilterExists = (searchFilters?: SearchFilters) => {
  return !!searchFilters?.fundingPrograms?.length;
};

export const updateFundingProgramSearchFilter = (
  searchFilters?: SearchFilters,
  programAbbreviation?: string | null
) => {
  if (!programAbbreviation || !!searchFilters?.fundingPrograms?.length) {
    return undefined;
  }

  return [programAbbreviation];
};
